module.exports = __webpack_public_path__ + "assets/CircleTangentPLDetailed.2475b33b699d14fb818235c2ac816ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentPLDetailed.png
// module id = 496
// module chunks = 0